import React, { useState } from 'react'
import st from './RowClientDuplicate.module.scss'
import ClientDuplicateCard from '../ClientDuplicateCard/ClientDuplicateCard'
import ActionCard from '../ActionCard/ActionCard'

const RowClientDuplicate = ({
  duplicate,
  setDuplicates,
  duplicates,
  fetchDuplicates,
}) => {
  const [clickedCards, setClickedCards] = useState([])
  const [selectedTab, setSelectedTab] = useState('dontMerge')

  //фу-ция выбора 2-х сделок
  const handleCardClick = (deal) => {
    setClickedCards((prev) => {
      if (prev.some((card) => card.id === deal.id)) {
        return prev.filter((card) => card.id !== deal.id)
      }

      if (prev.length === 2) {
        return [deal]
      }

      return [...prev, deal]
    })
  }

  return (
    <div className={st.container}>
      <div className={st.clientName}>{duplicate.name}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {clickedCards.length === 2 && (
          <div>
            <ActionCard
              duplicate={duplicate}
              selectedTab={selectedTab}
              onTabChange={setSelectedTab}
              clickedCards={clickedCards}
              setClickedCards={setClickedCards}
              setDuplicates={setDuplicates}
              duplicates={duplicates}
              fetchDuplicates={fetchDuplicates}
            />
          </div>
        )}
        <div className={st.cards}>
          {duplicate.deals.map((deal, index) => (
            <ClientDuplicateCard
              key={`${deal.id}${index}`}
              duplicate={duplicate}
              deal={deal}
              onClick={() => handleCardClick(deal)}
              isSelected={clickedCards.some((card) => card.id === deal.id)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default RowClientDuplicate
